import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  num: '01',
  title: 'Playlist Curada por Emoción',
  desc: '6 playlists completas con BPM específico por tomo. La música correcta para cada clase sin buscar nada.',
  value: '$12.000'
}, {
  num: '02',
  title: 'Ficha de Anamnesis Profesional',
  desc: 'Formulario completo, ficha express, ficha para adultos mayores y consentimiento informado editable. Listo para imprimir o compartir por WhatsApp.',
  value: '$9.000'
}, {
  num: '03',
  title: 'Guía de Variaciones en 3 Niveles',
  desc: '14 ejercicios clave del sistema en versión Fundacional, Estándar y Avanzada. Para dar la misma clase a cualquier grupo.',
  value: '$8.000'
}, {
  num: '04',
  title: 'Calendario Anual de Planificación',
  desc: '12 meses organizados semana a semana. Qué tomo, qué clase y qué meta cada semana del año. Sin decidir nunca más qué dar.',
  value: '$10.000'
}, {
  num: '05',
  title: 'Script de Primera Clase',
  desc: 'Qué decir exactamente en los 5 momentos clave de la primera clase para que la alumna nueva se quede y pague el mes.',
  value: '$9.000'
}, {
  num: '06',
  title: 'Pack de Flyers para WhatsApp e Instagram',
  desc: '18 diseños editables en Canva + calendario de 30 días de contenido listo para publicar. Nunca más la pregunta "¿qué publico hoy?".',
  value: '$8.000'
}];
export const BonusesSection = () => {
  return <section className="py-8 md:py-14 bg-sage-900 text-white" data-id="element-22">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="text-center mb-8 md:mb-16" data-id="element-24">
          <h2 className="text-2xl md:text-5xl font-bold font-playfair mb-2 md:mb-4" data-id="element-25">
            Más los 6 Bonos Estratégicos
          </h2>
          <p className="text-base md:text-xl text-sage-200" data-id="element-26">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-27">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 rounded-xl md:rounded-2xl p-4 md:p-6 hover:bg-white/10 transition-colors relative" data-id="element-28">
              <div className="absolute -top-3 -right-3 w-9 h-9 md:w-12 md:h-12 bg-gold text-sage-900 rounded-full flex items-center justify-center font-bold text-base md:text-xl shadow-lg transform rotate-12" data-id="element-29">
                🎁
              </div>
              <div className="text-sage-300 font-bold text-base md:text-xl mb-1 md:mb-2" data-id="element-30">
                Bono {bonus.num}
              </div>
              <h3 className="text-base md:text-xl font-bold text-white mb-2 md:mb-3 font-playfair" data-id="element-31">
                {bonus.title}
              </h3>
              <p className="text-gray-300 text-xs md:text-sm mb-4 md:mb-6 leading-relaxed flex-grow" data-id="element-32">
                {bonus.desc}
              </p>
              <div className="mt-auto flex items-center gap-2 md:gap-3" data-id="element-33">
                <span className="line-through text-gray-500 text-sm" data-id="element-34">
                  {bonus.value}
                </span>
                <span className="bg-gold text-sage-900 px-2.5 py-0.5 rounded-md text-xs font-bold uppercase tracking-wider" data-id="element-35">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gold/10 border border-gold/30 rounded-2xl md:rounded-3xl p-6 md:p-12 text-center max-w-3xl mx-auto" data-id="element-36">
          <p className="text-sage-200 uppercase tracking-widest font-semibold mb-1 md:mb-2 text-xs md:text-base" data-id="element-37">
            Valor total de los 6 bonos
          </p>
          <p className="text-4xl md:text-7xl font-bold text-gold font-playfair mb-3 md:mb-4" data-id="element-38">
            $56.000
          </p>
          <div className="inline-flex items-center gap-2 bg-gold text-sage-900 px-4 md:px-6 py-1.5 md:py-2 rounded-full font-bold text-sm md:text-lg" data-id="element-39">
            🎁 GRATIS — Incluidos siempre
          </div>
        </motion.div>
      </div>
    </section>;
};